import { ToggleButtonDesignTokens } from '@primeuix/themes/types/togglebutton';

export const togglebutton: ToggleButtonDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: '{surface.700}',
        borderColor: '{surface.700}',
        checkedBackground: '{surface.700}',
        checkedBorderColor: '{surface.700}',
        padding: '2px',
      },
      content: {
        checkedBackground: '{blue.400}',
        padding: '8px 30px',
      },
    },
  },
};
